<template>
  <div>
    <div v-if="!logueado">
      <p>
        Bienvenidos al sitio de autogestión para afiliados.
      </p>
      <p>
        Desde aquí, usted podrá y ver el estado de sus ordenes.
      </p>
      <Login
        @titularlogueado="logueotitular = true"
        @familiarlogueado="logueotitular = false"
      ></Login>
    </div>
    <div v-if="logueado">
      <div class="headeryfooter text-center">
        <h2 style="color: white">{{ Seleccionado.apellido_y_nombre }}</h2>
      </div>
      <v-tabs v-model="tab" dark background-color="primary">
        <v-tab>
          <v-icon left>mdi-clipboard-text-outline</v-icon>
          Mis Practicas
        </v-tab>
        <!-- <v-tab>
          <v-icon left>mdi-prescription</v-icon>
          Cargar Receta
        </v-tab> -->
        <v-tab v-if="logueotitular">
          <v-icon left>mdi-human-female-boy</v-icon>
          <v-badge color="orange" :content="GrupoFamiliar.length"
            >Grupo Familiar</v-badge
          >
        </v-tab>
        <v-tab-item>
          <lista nofiltrar
            v-if="!practicaselected"
            vertodas
            sololistar
            :items="ListaPorAfiliado"
            v-model="practicaselected"
          ></lista>
          <!-- <practica
            readonly
            autogestion
            v-if="practicaselected"
            :solic="practicaselected"
            @guardado="guardado()"
          ></practica> -->
        </v-tab-item>
        <!-- <v-tab-item>
          <altaPractica
            @practicaGuardada="traerPorAfiliado(Nuevo.id_afiliado)"
            class="pt-3"
            :id_afiliado="Nuevo.id_afiliado"
            :id_plan="Nuevo.id_plan"
            :IdImagenes="IdImagenes"
          ></altaPractica>
        </v-tab-item> -->
        <v-tab-item v-if="logueotitular">
          <listaGrupo grupo></listaGrupo>
        </v-tab-item>
      </v-tabs>
    </div>
  </div>
</template>

<script>
import Login from "@/components/Beneficiarios/Login";
// import lista from "@/components/Practica/ListaPorBeneficiario";
import lista from "@/components/Practica/Lista";
import altaPractica from "@/components/Practica/AltaAutogestion";
import practica from "@/components/Practica/Practica";
import listaGrupo from "@/components/Beneficiarios/ListaAfiliados";

import { mapActions, mapState } from "vuex";
export default {
  components: {
    altaPractica,
    lista,
    listaGrupo,
    Login,
    practica,
  },
  data() {
    return {
      tab: 0,
      IdImagenes: 0,
      practicaselected: undefined,
      logueotitular: false,
    };
  },
  computed: {
    ...mapState("autogestion", ["Usuario"]),
    //...mapState("beneficiarios", ["Nuevo"]),
    ...mapState("beneficiarios", ["Titular", "GrupoFamiliar", "Seleccionado"]),
    ...mapState("autorizaciones", ["ListaPorAfiliado"]),
    logueado() {
      return this.Nuevo !== undefined && this.Nuevo !== null;
    },
    Nuevo() {
      return this.Seleccionado;
    },
  },
  methods: {
    ...mapActions("autorizaciones", ["traerPorAfiliado"]),
    practicaGuardada() {
      this.traerPorAfiliado(this.Nuevo.id_afiliado);
    },
    guardado() {
      this.practicaselected = undefined;
      this.traerPorAfiliado(this.Nuevo.id_afiliado);
      this.IdImagenes = new Date().getTime();
    },
  },
  mounted() {
    this.IdImagenes = new Date().getTime();
  },
  watch: {
    Nuevo() {
      if (this.Nuevo) {
        this.IdImagenes = new Date().getTime();
        this.traerPorAfiliado(this.Nuevo.id_afiliado);
      }
    },
  },
};
</script>

<style></style>
